var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300.348 59.1",
    enableBackground: "new 0 0 300.348 59.1",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FA372C",
    d: "M27.15,24.557c-4.571,0-7.538,2.833-8.963,4.644c-0.342-0.663-0.755-1.249-1.244-1.771   c-1.725-1.827-4.156-2.873-6.67-2.873c-2.908,0-5.648,1.184-7.88,3.365v-2.891H0v22.247h2.392V31.518   c2.169-3.05,4.89-4.659,7.88-4.659c1.799,0,3.616,0.798,4.86,2.129c1.256,1.354,1.841,3.183,1.841,5.749v12.544h2.393V34.736   c0-1.027-0.082-1.972-0.243-2.808c0.845-1.447,3.436-5.07,8.124-5.07c1.798,0,3.615,0.798,4.859,2.129   c1.255,1.354,1.838,3.183,1.838,5.749v12.543h2.396V34.736c0-3.221-0.77-5.542-2.421-7.307   C32.161,25.577,29.757,24.557,27.15,24.557z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA372C",
    d: "M50.461,24.557c-6.452,0-11.316,4.988-11.316,11.604c0,6.504,4.972,11.599,11.316,11.599   c6.346,0,11.315-5.095,11.315-11.599C61.777,29.545,56.914,24.557,50.461,24.557z M50.461,45.459c-5.005,0-8.924-4.083-8.924-9.298   c0-5.218,3.919-9.304,8.924-9.304c5.002,0,8.921,4.086,8.921,9.304C59.382,41.376,55.463,45.459,50.461,45.459z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FA372C",
    points: "71.736,43.211 63.454,25.031 60.872,25.031 71.032,47.279 72.44,47.279 82.599,25.031    80.015,25.031  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA372C",
    d: "M85.02,16.049c-1.201,0-2.143,0.941-2.143,2.144c0,1.201,0.94,2.143,2.143,2.143s2.145-0.94,2.145-2.143   C87.163,16.99,86.222,16.049,85.02,16.049z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.827,
    y: 25.031,
    fill: "#FA372C",
    width: 2.392,
    height: 22.247
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA372C",
    d: "M101.521,24.557c-2.881,0-5.614,1.196-7.734,3.339v-2.863h-2.398v22.248h2.398V31.505   c1.995-2.998,4.737-4.646,7.734-4.646c1.945,0,3.937,0.834,5.194,2.179c1.304,1.404,1.886,3.16,1.886,5.699v12.544h2.394V34.736   c0-3.149-0.783-5.453-2.467-7.256C106.761,25.623,104.208,24.557,101.521,24.557z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA372C",
    d: "M132.899,27.565c-1.479-1.409-3.976-3.009-7.69-3.009c-6.503,0-11.409,5.006-11.409,11.646   c0,6.698,4.74,11.559,11.269,11.559c3.32,0,6.098-1.388,7.832-3.045v1.654c0,2.479-0.079,5.268-1.04,6.973   c-1.285,2.266-3.634,3.46-6.792,3.46c-4.198,0-7.086-2.213-8.281-4.107l-0.419-0.663l-1.936,1.455l0.395,0.571   c0.812,1.183,3.943,5.042,10.241,5.042c3.996,0,7.056-1.56,8.852-4.514c1.267-2.138,1.374-5.387,1.374-8.263V25.031H132.9   L132.899,27.565L132.899,27.565z M125.067,45.459c-5.226,0-8.876-3.808-8.876-9.258c0-5.327,3.916-9.344,9.11-9.344   c3.131,0,5.89,1.599,7.598,4.393v9.606C131.734,43.171,128.896,45.459,125.067,45.459z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FA372C",
    points: "173.906,37.01 168.188,23.63 163.93,23.63 158.161,37.01 152.58,23.63 146.387,23.63    156.035,46.556 160.288,46.556 166.056,33.227 171.818,46.556 176.077,46.556 185.725,23.63 179.532,23.63  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA372C",
    d: "M206.061,25.473c-1.798-1.47-4.116-2.317-6.718-2.317c-6.243,0-11.249,5.202-11.249,11.966   c0,3.122,1.126,5.955,2.924,8.03c2.036,2.37,5.254,3.886,8.653,3.886c2.318,0,4.489-0.713,6.39-2.323v1.843h5.904V23.63h-5.904   V25.473z M205.817,38.52c-1.177,1.702-3.212,2.834-5.535,2.834c-3.444,0-6.046-2.646-6.046-6.232c0-3.313,2.313-6.294,5.908-6.294   c2.365,0,4.396,1.137,5.673,2.837V38.52z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.001,
    y: 12.988,
    fill: "#FA372C",
    width: 6.146,
    height: 33.567
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA372C",
    d: "M250.019,25.281c-1.793-1.42-3.965-2.128-6.469-2.128c-6.244,0-11.255,5.203-11.255,11.967   c0,3.122,1.131,5.955,2.929,8.03c2.03,2.37,5.249,3.886,8.653,3.886c2.317,0,4.49-0.713,6.379-2.323v1.843h5.916V12.988h-6.153   V25.281z M250.019,38.52c-1.177,1.702-3.207,2.834-5.529,2.834c-3.45,0-6.047-2.646-6.047-6.232c0-3.313,2.313-6.294,5.903-6.294   c2.364,0,4.4,1.137,5.673,2.837V38.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA372C",
    d: "M274.517,23.154c-6.95,0-12.204,5.343-12.204,11.967c0,6.616,5.254,11.916,12.204,11.916   c6.944,0,12.192-5.3,12.192-11.916C286.709,28.496,281.461,23.154,274.517,23.154z M274.517,41.354   c-3.597,0-6.056-2.789-6.056-6.232c0-3.457,2.459-6.294,6.056-6.294c3.585,0,6.051,2.837,6.051,6.294   C280.567,38.564,278.102,41.354,274.517,41.354z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA372C",
    d: "M292.433,0.521c-3.434,0-6.21,2.781-6.21,6.215c0,3.433,2.776,6.217,6.21,6.217   c3.438,0,6.209-2.785,6.209-6.217C298.642,3.302,295.87,0.521,292.433,0.521z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9e5300a441abf8fb022e49b399243273.svg";
export { ForwardRef as ReactComponent };